<template>
  <info-action-button
    :label="label"
    :icon="icon"
    :color="done ? $theme.primaryColor : null"
    :border-color="done ? $theme.primaryColor : null"
    :title="title"
    :width="112"
    @click="toggle"
  />
</template>

<script>
import InfoActionButton from '@/components/InfoActionButton';

// Marcar/desmarcar a aula como concluída. No app substitui o checkbox: os três
// gestos da linha (avaliar, concluir, baixar) viram o mesmo tipo de alvo, em vez
// de um checkbox de 15px espremido entre dois botões de 35px.
//
// Só a apresentação muda — o dispatch é o mesmo que o checkbox fazia, inclusive
// o toggle (clicar numa aula concluída volta pra 0).
export default {
  name: 'LessonCompleteButton',
  components: { InfoActionButton },
  props: {
    enroll: { type: Object, required: true },
    learningObject: { type: Object, required: true }
  },
  computed: {
    done () {
      return this.learningObject.progress === 100;
    },
    label () {
      return this.done ? 'Concluído' : 'Concluir';
    },
    // Círculo vazio → círculo cheio. O botão de download usa o check de CONTORNO
    // no estado final, então o preenchido aqui mantém os dois distinguíveis
    // mesmo com os dois ativos na mesma linha.
    icon () {
      return this.done ? 'check_circle' : 'radio_button_unchecked';
    },
    title () {
      return this.done
        ? 'Concluída — toque para desmarcar'
        : 'Marcar esta aula como concluída';
    }
  },
  methods: {
    async toggle () {
      const lo = this.learningObject;
      await this.$store.dispatch('enroll/setProgress', {
        enrollId: this.enroll.id,
        courseId: this.enroll.courseId,
        moduleId: lo.moduleId,
        disciplineId: lo.disciplineId,
        classId: lo.classId,
        learningObjectId: lo.id,
        broadcastId: lo.broadcast ? lo.broadcast.id : null,
        progress: lo.progress < 100 ? 100 : 0
      });
      // Offline o setProgress enfileira e o total do curso só faz sentido depois
      // do flush — por isso o guard.
      if (this.$store.getters['dom/isConnected']) {
        this.$store.dispatch('enroll/getCourseProgress', this.enroll.id);
      }
    }
  }
};
</script>
